"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buildFont(aMayus, aLower, digit0, missing, name, description) {
    if (description === void 0) { description = ''; }
    var font = [];
    for (var i = 65; i < 91; i++) {
        var value = typeof aMayus === 'number' ? aMayus + i - 65 : aMayus[i - 65];
        font.push([i, value]);
    }
    for (var i = 97; i < 123; i++) {
        var value = typeof aMayus === 'number' ? aMayus + i - 97 : aMayus[i - 97];
        font.push([i, value]);
    }
    for (var i = 48; i < 58; i++) {
        var value = typeof digit0 === 'number' ? digit0 + i - 48 : digit0[i - 48];
        font.push([i, value]);
    }
    digit0;
    return { chars: font, missing: missing, name: name, description: description };
}
exports.buildFont = buildFont;
//# sourceMappingURL=buildFont.js.map